import User from "@/pages/administrer/users_profiles/User.vue";
import ShowUser from "@/pages/administrer/users_profiles/ShowUser.vue";
import CreateUser from "@/pages/administrer/users_profiles/CreateUser.vue";

export default [{
    path: 'users/create',
    meta: { permissions: ["create_user"] },
    name: "AdminUserProfileCreateUser",
    component: CreateUser,

},
{
    path: 'users/:id/show',
    meta: { permissions: ["view_any_user"] },
    name: "AdminUserProfileShowUser",
    component: ShowUser,
},
{
    path: 'users',
    meta: { permissions: ["view_user"] },
    name: "AdminUserProfileUser",
    component: User,

}]